import { CurrencyCodeUsd } from 'constants/currency';
export const rejectMultiZeroesBeforeDecimalSeparator = (value = '') => !/^(\$)?(0{2,})(\.)/.test(value);
export const isCurrencyCodeUSD = (currencyCode) => currencyCode === CurrencyCodeUsd;
export const isCurrencyCodeNonUSD = (currencyCode) => !currencyCode || !isCurrencyCodeUSD(currencyCode);
export const mapCurrencyCodeToSelectOption = (currencyCode) => ({
    id: currencyCode,
    value: currencyCode,
    text: currencyCode,
});
